import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiUri: "https://wifi-dev.plusmore.co.za/api",
  version: packageJson.version,
};
